import { render } from "./AlertBanners.vue?vue&type=template&id=e8ddff0e&scoped=true"
import script from "./AlertBanners.vue?vue&type=script&lang=js"
export * from "./AlertBanners.vue?vue&type=script&lang=js"

import "./AlertBanners.vue?vue&type=style&index=0&id=e8ddff0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ddff0e"]])

export default __exports__